import React from "react";

const LandingPageStep = ({ stepNumber, strongText, text } = props) => {
	return (
		<div className="offers-landing-page-step">
			<div className="offers-landing-page-step--number">
				<span className="offers-landing-page-step--number--indicator">{stepNumber}</span>
			</div>
			<p>
				<strong>{strongText}</strong>
				<br />
				{text}
			</p>
		</div>
	);
};

export default LandingPageStep;
